// Updated client/src/services/authService.js with product support
import { api } from "./api";

export const register = async (data) => {
  try {
    // Support both old format (email, password) and new format with productIds
    const registrationData = {
      email: data.email,
      password: data.password,
      ...(data.productIds && { productIds: data.productIds }),
      ...(data.role && { role: data.role }),
    };

    // Choose endpoint based on whether it's admin creating user
    const endpoint =
      (data.productIds && data.productIds.length > 0) ||
      (data.role && data.role !== "user")
        ? "/auth/admin/create-user"
        : "/auth/register";

    const response = await api.post(endpoint, registrationData);

    // Store token in localStorage only if provided (not for admin-created users)
    if (response.data.token) {
      localStorage.setItem("token", response.data.token);
    }

    return response.data;
  } catch (error) {
    console.error("Registration error:", error);
    throw error.response?.data || error;
  }
};

export const login = async (email, password) => {
  try {
    const response = await api.post("/auth/login", { email, password });

    // Store token in localStorage
    if (response.data.token) {
      localStorage.setItem("token", response.data.token);
    }

    return response.data;
  } catch (error) {
    console.error("Login error:", error);
    throw error.response?.data || error;
  }
};

export const logout = () => {
  localStorage.removeItem("token");
};

export const forgotPassword = async (email) => {
  try {
    const response = await api.post("/auth/forgot-password", { email });
    return response.data;
  } catch (error) {
    console.error("Forgot password error:", error);
    throw error.response?.data || error;
  }
};

export const resetPassword = async (token, password) => {
  try {
    const response = await api.post("/auth/reset-password", {
      token,
      password,
    });
    return response.data;
  } catch (error) {
    console.error("Reset password error:", error);
    throw error.response?.data || error;
  }
};

export const getCurrentUser = () => {
  const token = localStorage.getItem("token");
  if (!token) return null;

  try {
    // Decode JWT token to get user info
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload;
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
};
